import { dApi } from "./d-api";

export default {
  data: function() {
    return {
      dovemedUser: null,
      authenticationRequestSent: false,
      isPhysician: null,
      isAuthenticated: null,
      isVerified: null,
      showSurvey: null,
      dovemedUserImage: null,
      dovemedUserInitial: null
    };
  },
  methods: {
    getUserData: function() {
      const self = this;
      self.authenticationRequestSent = true;
      dApi.get("/api/user/").then(function(res) {
        self.dovemedUser = res.data;
        // console.log(res.data);
        // localStorage.setItem("user-details",res.data);
        self.userEmail = "example@dovemed.com";
        self.userImage = res.data.picture;
        self.dovemedUser && self.dovemedUser.username
          ? (self.dovemedUserInitial = self.dovemedUser.username
              .charAt(0)
              .toUpperCase())
          : (self.dovemedUserInitial = null);
        self.isAuthenticated = res.data.authenticated;
        self.isVerified = res.data.verified_account;
        self.isPhysician = res.data.is_physician;
        self.isOhcp = res.data.is_ohcp;
        self.showSurvey = res.data.show_survey;
      });
    },

    login: function(data) {
      return dApi.post(
        `${process.env.SSO_BASE_URL}/${process.env.SSO_LOGIN_URL}`,
        data
      );
    },

    register: function(data) {
      console.log('auth.js -> register()');
      return dApi.post(
        `${process.env.SSO_BASE_URL}/${process.env.SSO_REGISTER_URL}`,
        data
      );
    },

    resendEmailVerification: function(data) {
      // return dApi.post(
      //   `${process.env.SSO_BASE_URL}/api/v1/signupresend/`,
      //   data
      // );/api/v2/accounts/verification/create-new-link/

      return dApi.post(
        `${process.env.SSO_BASE_URL}/api/v2/accounts/verification/create-new-link/`,
        data
      );
    },

    getUser: function() {
      return dApi.get(`${process.env.SSO_BASE_URL}/api/v2/rest-auth/user/`);
    },

    logout: function() {
      return dApi.get(`${process.env.SSO_BASE_URL}/api/v2/rest-auth/logout/`);
    }
  },
  created() {
    if (!this.authenticationRequestSent) {
      this.getUserData();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/login/utils/auth.js